/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { WebSocketManager } from "./WebSocketManager";
export { WebSocketConnectionHolder } from "./WebSocketConnectionHolder";
export { WebSocketJwtService } from "./WebSocketJwtService";
export { WebSocketTransport } from "./WebSocketTransport";
export { WebSocketMrpcv2Enveloper } from "./WebSocketMrpcv2Enveloper";
export { WebSocketSerializer } from "./WebSocketSerializer";
export { WebSocketPingManager } from "./WebSocketPingManager";
export { WebSocketLifecycleManager } from "./WebSocketLifecycleManager";
export {
  WebSocketCircuitBreaker,
  CircuitBreakerState
} from "./WebSocketCircuitBreaker";

export {
  WebSocketConnectionState,
  ConnectionTrigger,
  WebSocketObservableState,
  WebSocketFsmState,
  MrpcMessageType,
  TransportEventType,
  WebSocketErrorCode,
  WebSocketError
} from "./types";

export type {
  IWebSocketMessage,
  IWebSocketConfig,
  IOutboundBufferEntry,
  ITransportOpenEvent,
  ITransportTextMessageEvent,
  ITransportBinaryMessageEvent,
  ITransportErrorEvent,
  ITransportClosedEvent,
  TransportEvent,
  TransportEventListener,
  WebSocketStateListener,
  OperationHandler
} from "./types";
